import React from 'react'
import './Infrastructure.css'
import Slider from '../../Home/Slider/Slider'
import Library1 from "../Gallery/ImageGallery/IMG_6970.JPG"
import Transport1 from '../../Home/images/maxresdefault.jpg'
import hostelimage1 from '../../Home/images/hostel image.jpg'
import Cafeteria12 from '../../Home/images/OIP (2).jpg'
const Infrastructure = () => {
  return (
    <div className='main-container-infrastructure'>
        <Slider></Slider>
        <div className='container-infrastructure'>
        
            <div className='Library'> 
            <div data-aos="fade-up"
              data-aos-duration="3000">
             <h1>Library</h1><br />  
            <p>The Library is the heart, mind & soul of an educational institution and a fountainhead of innovativeness, inspiration and insight both for the students and the faculty. Learning and Library are to each other as the light to the lamp. Pt. L. R. Group of Institutions has about 500 sqr. meter of carpet area and can accommodate 1800 students to carry out any academic activity such as reading books & journals, digital library section, computer programming, software development etc.</p> 
            </div>
            <div data-aos="fade-up"
              data-aos-duration="3000">
            <div className='Library2'>
            <img src={Library1} alt='infrastructure' className='Library1' />
                
               <p className='para4'> The centre has a vast collection of international journals. It’s fully linked to the Internet, and all students, faculty members and employees of the institute are entitled to use the library facilities by taking a library membership. The Library is in a separate area in the college building with an air-conditioned facility. It has been systematically and steadily strengthened. The library operation and LIBRARY HOSTEL services are fully computerized with a Bar-Code-based circulation system. The Library is equipped with more than 20000 books from different streams. Besides these texts and reference books, the Library also subscribes to many national and international journals, magazines, Encyclopedia, and DELNET databases. Bibliographic records of Library holdings can be accessed through the On-Line Public Access Catalogue (OPAC). The Library also maintains a good collection of essential educational CDs/DVDs on Engineering & Technology Services provided by the Library. </p> <hr />
                </div> <br />  
                </div>
            </div> <br /> <hr />
            <div data-aos="fade-up"
             data-aos-duration="7000">

            <div className='Hostel'> 
              <h1 className='Hostel1'> 
                Hostel
              </h1> <br />
              <div className='hostel3'>
              <img src={ hostelimage1} alt='infrastructure 1' className='Library1' /> 
              <p>The Institute provides adequate accommodation for the Boys and Girls with a homely environment conducive to studies – The boy’s and Girls hostel has a capacity of 150 and 100 students, respectively. Each room accommodates two students and is well decorated with furniture, mattress, curtains and a study table. Each room is provided with an air cooler and two ceiling fans. The bathroom is fitted with geysers. Each hostel has two wardens to care for students around the clock—various recreational facilities like WiFi internet, TV, and Indoor games. Like Table Tennis, Magazines and Telephone facilities are available in the hostel. Other facilities like round-the-clock vigilant security of the campus and 100% power backup are available in the hostel.</p> <hr />
            </div>
            </div>  
            </div>
            <div className='Transport'>
            <div data-aos="fade-up"
             data-aos-easing="linear"
             data-aos-duration="1000">
             <h1>Transport</h1>  <br /> 
            </div>
            <div data-aos="fade-up"
             data-aos-easing="linear"
             data-aos-duration="1000">
              <div className='Transport1'> 
                <img src={Transport1}  alt='infrastructure3' className='Transport12' />  
                <p>The Institute has a fleet of buses that ply across several routes of NCR and its neighbouring areas, i.e., Delhi, Ballabhgarh, Palwal, and Sohna, serving students and staff. Students are charged on a routine basis. Regular state transport on Haryana roadways is also available. For the convenience of our students, a nominal fee is charged on a routine basis to cover the costs associated with the transportation service. This ensures that students can focus on their studies and extracurricular activities without worrying about the complexities of commuting.</p> <hr />
              </div>
            </div>
            
            </div> 
            <div className='Cafeteria'>
            <div data-aos="fade-up"
               data-aos-anchor-placement="top-bottom">

            <h1>Cafeteria</h1> <br /> 
            
              <div className='Cafeteria1'>
                <img src={Cafeteria12}  alt='infrastructure4' className='Cafeteria12' />  
                <p>College is running vibrate and modern Cafeteria within the college premises. All the students use it to un-wind themselves after a hectic schedule in the classroom. College Cafeteria provides various cuisines such as Fast Food, South Indian, and Chinese Food & Indian cuisines. College ensures high quality standards and hygienic food and offers students delicious snacks and other nutritious foods round the clock. Committee which consist of staff representatives and students representatives conduct regular check over the food quality.</p> <hr />
              </div>
              </div>
            </div> 
        </div>    
    </div>
  )
}

export default Infrastructure
